import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", path: "/" },
  { label: "分类浏览", path: "/category" },
  { label: "文章中心", path: "/category" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="container-page">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="text-2xl md:text-3xl font-heading font-bold" style={{ fontFamily: "'Dancing Script', cursive" }}>
              <span className={isScrolled ? "text-primary-500" : "text-white"}>
                爱情岛
              </span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`whitespace-nowrap text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path
                    ? isScrolled
                      ? "text-primary-500"
                      : "text-white font-semibold"
                    : isScrolled
                      ? "text-foreground-700 hover:text-primary-500"
                      : "text-white/80 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category"
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                isScrolled
                  ? "border border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50"
                  : "border border-white/60 text-white hover:bg-white hover:text-primary-500"
              }`}
            >
              浏览文章
            </Link>
            <a
              href="#"
              className="whitespace-nowrap px-5 py-2 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              立即注册
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? "text-foreground-900" : "text-white"
            }`}
            aria-label="菜单"
          >
            <i className={`ri-${isMobileMenuOpen ? "close" : "menu"}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="container-page py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? "bg-primary-100 text-primary-600"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-2 px-4">
              <Link
                to="/category"
                className="flex-1 text-center px-4 py-2.5 rounded-full text-sm font-medium border border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                浏览文章
              </Link>
              <a
                href="#"
                className="flex-1 text-center px-4 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                立即注册
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}